const teacherApiRoot = process.env.REACT_APP_LMS_API || '';
const performanceStudentBase = process.env.REACT_APP_API_PERFORMANCE_TASK || `${teacherApiRoot}api/PerformanceTask`;

export const MICROCREDENTIALS_TASK_MODES = {
   PERFORMANCE: 'performance',
   WRITTEN_WORKS: 'written_works',
};

const MODULE_CONFIGS = {
   [MICROCREDENTIALS_TASK_MODES.PERFORMANCE]: {
      mode: MICROCREDENTIALS_TASK_MODES.PERFORMANCE,
      taskType: 'performance',
      label: 'Performance Task',
      labelPlural: 'Performance Tasks',
      myLabel: 'My Performance Task',
      myLabelPlural: 'My Performance Tasks',
      teacherBase: `${teacherApiRoot}api/microcredentials/performance-tasks`,
      studentBase: performanceStudentBase,
      teacherListRoute: '/microcredentials/performance-tasks',
      teacherCourseRoute: '/microcredentials/performance-tasks/course',
      studentListRoute: '/studentmicrocredentials/performance-tasks',
      studentSubjectsRoute: '/studentmicrocredentials/performance-tasks/subjects',
   },
   [MICROCREDENTIALS_TASK_MODES.WRITTEN_WORKS]: {
      mode: MICROCREDENTIALS_TASK_MODES.WRITTEN_WORKS,
      taskType: 'written_works',
      label: 'Written Works',
      labelPlural: 'Written Works',
      myLabel: 'My Written Works',
      myLabelPlural: 'My Written Works',
      teacherBase: `${teacherApiRoot}api/microcredentials/written-works`,
      studentBase: `${teacherApiRoot}api/written-works`,
      teacherListRoute: '/microcredentials/written-works',
      teacherCourseRoute: '/microcredentials/written-works/course',
      studentListRoute: '/studentmicrocredentials/written-works',
      studentSubjectsRoute: '/studentmicrocredentials/written-works/subjects',
   },
};

export function getMicrocredentialsTaskModule(mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   return MODULE_CONFIGS[mode] || MODULE_CONFIGS[MICROCREDENTIALS_TASK_MODES.PERFORMANCE];
}

export function getMicrocredentialsTaskType(mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   return getMicrocredentialsTaskModule(mode).taskType;
}

export function getMicrocredentialsTaskLabel(mode = MICROCREDENTIALS_TASK_MODES.PERFORMANCE) {
   return getMicrocredentialsTaskModule(mode).label;
}


export function detectMicrocredentialsTaskMode(pathname = '') {
   const normalizedPath = String(pathname || '').toLowerCase();
   return normalizedPath.includes('written-works')
      ? MICROCREDENTIALS_TASK_MODES.WRITTEN_WORKS
      : MICROCREDENTIALS_TASK_MODES.PERFORMANCE;
}
